import React, { FC, memo } from "react";
import Button, { ButtonProps } from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

export interface GenButtonProps extends ButtonProps {
  loading?: boolean;
  loadingColor?: string;
}

const GenButton: FC<GenButtonProps> = (props) => {
  const {
    loading,
    color,
    children,
    loadingColor = "secondary",
    ...otherProps
  } = props;
  return (
    <Button
      color={color || "primary"}
      variant="contained"
      endIcon={
        loading && (
          <CircularProgress
            sx={{
              color: loadingColor || "inherit",
            }}
            size={18}
          />
        )
      }
      {...otherProps}
    >
      {children}
    </Button>
  );
};

export default memo(GenButton);
